import React from 'react'

import { ProductImage } from '../../../../core/components'
import { useSelectedSkuLowResolutionImage } from './hooks'

export const ProductSkuImageLoading = () => {
  const selectedSkuLowResolutionImage = useSelectedSkuLowResolutionImage()

  return <ProductImage src={selectedSkuLowResolutionImage} alt="Loading..." />
}
